import React, { FC } from 'react';

import styles from './MonitorWarningIcon.module.scss';

const MonitorWarningIcon: FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width="65"
         height="65"
         fill="none"
         viewBox="0 0 65 65">
      <path className={styles.stand}
            d="M41.5 60H25l1.4-9.5H40l1.4 9.5Z" />
      <path className={styles.border}
            d="M2.5 48v1.3c0 2 1.8 3.7 4 3.7h52a4 4 0 0 0 4-3.8V48h-60Z" />
      <path className={styles.display}
            fillRule="evenodd"
            d="M6.4 6h52.2a4 4 0 0 1 3.9 4v38h-60V10a4 4 0 0 1 4-4Z"
            clipRule="evenodd" />
      <path className={styles.border}
            d="M48.3 64.1h-30c0-3 2.5-5.4 5.5-5.4h19c3 0 5.5 2.4 5.5 5.4Z" />
      <path className={styles.warningIcon}
            d="M30.2 14.7c.6-1 1-1.5 1.3-1.7h1c.4.2.7.7 1.3 1.7l12.9 22.7c.6 1 .8 1.6.8 2 0 .3-.2.6-.5.8-.3.3-1 .3-2.1.3H19.1c-1.2 0-1.8 0-2.1-.3-.3-.2-.4-.5-.5-.8 0-.4.2-1 .8-2l13-22.7Z" />
      <rect width="2.5"
            height="11.4"
            x="30.7"
            y="21.1"
            className={styles.display}
            rx="1.3" />
      <rect width="2.5"
            height="2.5"
            x="30.7"
            y="34.3"
            className={styles.display}
            rx="1.3" />
    </svg>
  );
};

export default MonitorWarningIcon;
